// Welle U10: Impressum + Datenschutzerklärung aus GET /api/rechtliches (ohne Anmeldung).
// Einzige Quelle ist server/lib/rechtliches.js — hier nur laden und typisieren.
import { API_BASE } from '../../lib/api';

export interface Verarbeitung {
  zweck: string;
  rechtsgrundlage: string | null;
  daten: string[];
  speicherdauer: string;
  empfaenger: string;          // lesbarer Text aus der zentralen Empfänger-Liste
  empfaenger_ids: string[];
  drittland?: string;
}
export interface Empfaenger { id: string; name: string; rolle: string; standort?: string; drittland?: string }
export interface DseAbschnitt { titel: string; absaetze?: string[]; typ?: 'verarbeitungen' | 'empfaenger' }
export interface Impressum {
  name: string;
  anschrift: string[];
  email: string;
  zweiter_kontakt: { art: string; wert: string } | null;
  ust_idnr: string | null;
}
export interface Rechtliches {
  impressum: Impressum;
  datenschutzerklaerung: {
    stand: string;
    fassung: string;
    verantwortlicher: { name: string; email: string; anschrift: string };
    abschnitte: DseAbschnitt[];
    verarbeitungen: Verarbeitung[];
    empfaenger: Empfaenger[];
  };
}

let cache: Promise<Rechtliches> | null = null;
export function ladeRechtliches(): Promise<Rechtliches> {
  if (!cache) {
    cache = fetch(`${API_BASE}/api/rechtliches`).then(r => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    });
    cache.catch(() => { cache = null; }); // nächster Versuch lädt neu
  }
  return cache;
}
